import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import store from "../../../../../../redux";
import './index.scss'
import {Button, Modal, Input, message,Collapse} from "antd";
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getInfo} from "../../../../../../servers/menuAPI";
import { getStorage,gotonext} from "@/utils";
import {refreshMenu} from "../../../../../../redux/common/action";
import {selectPicDetail} from "../../../../../../servers/menu";
import {dpeselectmap} from "../../../../../../utils/dpedatadef";

const { Panel } = Collapse;
@CBaseComponent
class SystemScore extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.lookscore = this.lookscore.bind(this)
    this.downloads = this.downloads.bind(this)
    this.handlePreview = this.handlePreview.bind(this)
    this.handleCancelstatus = this.handleCancelstatus.bind(this)
    this.modalCancel = this.modalCancel.bind(this)
  }


  state = {
    data: [],
    tips:'',
    isModalVisible:false,
    previewImage:'',
    detailstatus: false,
    detaildata:[],
  }

  showModal = () => {
    this.setState({
      isModalVisible:true
    })
  };

  handleCancel = () => {
    this.setState({
      isModalVisible:false
    })
  };

  onSubmit(data){
    gotonext()
    this.props.history.push({
      pathname: '/informationDeclaration/service/science/serviceProvince',
    });
  }

  onSelect(){
    const params = {
      annual:localStorage.getItem('year'),
      indid:'2.1.1',
      museumid:store.getState().libraryid,
    }
    getInfo(params).then(res=>{
      if (res.extra.dbxyjcghjxx!=='') {
        const dbxyjcghjxxArr = dpeselectmap[res.extra.dbxyjcghjxx.substr(0,2)]
        dbxyjcghjxxArr.forEach(item=>{
          if (item.id === res.extra.dbxyjcghjxx) {
            res.extra.dbxyjcghjxx = item.name
          }
        })
      }

      if(res.extra.dbxyjcgxmjb !=='') {
        const dbxyjcgxmjbArr = dpeselectmap[res.extra.dbxyjcgxmjb.substr(0,2)]
        dbxyjcgxmjbArr.forEach(item=>{
          if (item.id === res.extra.dbxyjcgxmjb) {
            res.extra.dbxyjcgxmjb = item.name
          }
        })
      }

      if (res.extra.dbxyjcgkwsylx !=='') {
        const dbxyjcgkwsylxArr = dpeselectmap[res.extra.dbxyjcgkwsylx.substr(0,2)]
        dbxyjcgkwsylxArr.forEach(item=>{
          if (item.id === res.extra.dbxyjcgkwsylx) {
            res.extra.dbxyjcgkwsylx = item.name
          }
        })
      }

      this.setState({
        data:res.records,
        tips: res.extra?res.extra:''
      },()=>{
        const element = document.getElementById('top');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动到元素位置
        }
      })
    })
  }

  computedData(data){
    const str = data.replaceAll('\n', '</br>')
    return <div dangerouslySetInnerHTML={this.createMarkup(str)}></div>;
  }

  createMarkup(str) {
    return {__html: str}
  }

  changeinput(e,index){
    e.persist()
    const d = this.state.data
    d.forEach((item,i)=>{
      if (index === i) {
        item.score = e.target.value
      }
    })
    this.setState({
      data:d
    })
  }

  async handlePreview(file){
    const params = {
      fileid: file.fileid
    }
    let timer = null
    selectPicDetail(params).then(res=>{
      if (res.statecode === 0 && res.records[0].filepreviewurl !== '' && res.records[0].filepreviewurl !== null) {
        const type = res.records[0].filename.split('.')[res.records[0].filename.split('.').length - 1]
        clearTimeout(timer)
        window.open(res.records[0].filepreviewurl, '_blank')
      } else {
        timer = setTimeout(()=>{
          this.handlePreview(file)
        },1)
      }
    })
  }

  downloads(file){
    const params = {
      fileid: file.fileid
    }
    let timer = null
    selectPicDetail(params).then(res=>{
      if (res.statecode === 0 && res.records[0].fileurl !== '' && res.records[0].fileurl !== null) {
        clearTimeout(timer)
        window.location.href = res.records[0].fileurl
      } else {
        timer = setTimeout(()=>{
          this.handlePreview(file)
        },1)
      }
    })
  }

  // modal取消
  modalCancel(){
    this.setState({
      previewVisible: false
    })
  }

  componentWillUnmount() {
    // 在组件卸载时取消订阅
    if (this.unsubscribe) this.unsubscribe();
  }

   componentDidMount(){
    this.onSelect()
    let currentState = store.getState();
    this.unsubscribe = store.subscribe(() => {
      let previousState = currentState;
      currentState = store.getState();
      if (previousState.libraryid !== currentState.libraryid) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
      if (previousState.year !== currentState.year) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
    })
  }

  computedData(data){
    const str = data.replaceAll('\n', '</br>')
    return <div dangerouslySetInnerHTML={this.createMarkup(str)}></div>;
  }

  createMarkup(str) {
    return {__html: str}
  }

  changeinput(e,index){
    e.persist()
    const d = this.state.data
    d.forEach((item,i)=>{
      if (index === i) {
        item.score = e.target.value
      }
    })
    this.setState({
      data:d
    })
  }

  lookscore(data){
    data.forEach((item,index)=>{
      if (index!==0) {
        item[0] = index
      }
    })
    this.setState({
      detailstatus:true,
      detaildata:data,
    })
  }

  handleCancelstatus(){
    this.setState({
      detailstatus:false
    })
  }

  render(){
    return (
        <div className='detail-container' id="top">
          {this.state.tips.scoretips?
              <div className="import">
                <Collapse accordion>
                  <Panel header="考察要点" key="1">
                    <div style={{fontWeight:'bold',color:'red',fontSize:'18px'}}>
                      {this.state.tips!==''?this.computedData(decodeURIComponent(this.state.tips.scoretips)):''}
                    </div>
                  </Panel>
                </Collapse>
              </div>:''
          }
          {this.state.data.map((item,index)=>{
            return (
                <div className="detail-item">
                  <div className='detail-title'>
                    <span>{item.name}</span>
                    <div className='detail-score'>
                          <div style={{display:'flex',alignItems:'center'}}>
                            <div className='scoreintro'>{item.scorelabel}</div>
                            {
                              item.type === '1G10' ? '' :
                                  item.scoredetaillist && item.scoredetaillist.length > 0 ?
                                  <Button size="small" type="primary" onClick={()=>{this.lookscore(item.scoredetaillist)}} style={{marginTop:0,fontSize:'12px'}}>
                                    查看
                                  </Button>
                                  :''}
                              </div>
                    </div>
                  </div>
                  <div className='detail-content'>
                     {this.computedData(decodeURIComponent(item.fillin))}
                  </div>
                  <ul className='uploadlistScore'>
                    {
                      item.annexlist.length>0?
                          item.annexlist.map((item1,index1)=>{
                            return <li>
                              <span>{index1+1}.{item1.filename}</span>
                              <div>
                                <span className="textbtn" onClick={()=>{this.downloads(item1)}}>下载</span>
                                <span className="textbtn" onClick={()=>{this.handlePreview(item1)}}>预览</span>
                              </div>
                            </li>
                          }):''
                    }
                  </ul>
                </div>
            )
          })}
          <div className="detail-item">
            <div className='detail-title'>
              <span>代表性研究成果</span>
            </div>
            <div className='detail-content'>
              {this.state.tips.dbxyjcgmc}
            </div>
          </div>
          <div className="detail-item">
            <div className='detail-title'>
              <span>成果名称</span>
            </div>
            <div className='detail-content'>
              {this.state.tips.dbxyjcgmc}
            </div>
          </div>
          <div className="detail-item">
            <div className='detail-title'>
              <span>第一完成人</span>
            </div>
            <div className='detail-content'>
              {this.state.tips.dbxyjcgdywcr}
            </div>
          </div>
          <div className="detail-item">
            <div className='detail-title'>
              <span>获奖信息</span>
            </div>
            <div className='detail-content'>
              {this.state.tips.dbxyjcghjxx && this.state.tips.dbxyjcghjxx !==''?this.state.tips.dbxyjcghjxx:''}
            </div>
          </div>
          <div className="detail-item">
            <div className='detail-title'>
              <span>主要合作单位或合作者</span>
            </div>
            <div className='detail-content'>
              {this.state.tips.dbxyjcgzyhzdw}
            </div>
          </div>
          <div className="detail-item">
            <div className='detail-title'>
              <span>是否受项目资助</span>
            </div>
            <div className='detail-content'>
              {this.state.tips.dbxyjcgsxmzz  === 'n' ? '否' : '是'}
            </div>
          </div>
          <div className="detail-item">
            <div className='detail-title'>
              <span>项目级别</span>
            </div>
            <div className='detail-content'>
              {this.state.tips.dbxyjcgxmjb && this.state.tips.dbxyjcgxmjb !== '' ?this.state.tips.dbxyjcgxmjb :''}
            </div>
          </div>
          <div className="detail-item">
            <div className='detail-title'>
              <span>项目名称</span>
            </div>
            <div className='detail-content'>
              {this.state.tips.dbxyjcgxmmc}
            </div>
          </div>
          <div className="detail-item">
            <div className='detail-title'>
              <span>项目编号</span>
            </div>
            <div className='detail-content'>
              {this.state.tips.dbxyjcgxmbh}
            </div>
          </div>
          <div className="detail-item">
            <div className='detail-title'>
              <span>项目金额（万元）</span>
            </div>
            <div className='detail-content'>
              {this.state.tips.dbxyjcgxmje}
            </div>
          </div>
          <div className="detail-item">
            <div className='detail-title'>
              <span>是否正式出版或发表</span>
            </div>
            <div className='detail-content'>
              {this.state.tips.dbxyjcgzscb === 'n' ? '否' : '是'}
            </div>
          </div>
          <div className="detail-item">
            <div className='detail-title'>
              <span>刊物索引类型</span>
            </div>
            <div className='detail-content'>
              {this.state.tips.dbxyjcgkwsylx && this.state.tips.dbxyjcgkwsylx!==''?this.state.tips.dbxyjcgkwsylx:''}
            </div>
          </div>
          <div className="detail-item">
            <div className='detail-title'>
              <span>文章或著作名称</span>
            </div>
            <div className='detail-content'>
              {this.state.tips.dbxyjcgwzmc}
            </div>
          </div>
          <div className="detail-item">
            <div className='detail-title'>
              <span>刊物名称及年卷期号</span>
            </div>
            <div className='detail-content'>
              {this.state.tips.dbxyjcgkwmc}
            </div>
          </div>
          <div className='detail-submit' style={this.props.collapsed?{width:'calc(100vw - 260px)',left:'260px'}:{width:'calc(100vw - 5px)',left:'50px'}}>
            <Button type="primary" className='yl' onClick={this.onSubmit}>下一步</Button>
          </div>
          <Modal title="附件预览" visible={this.state.previewVisible} footer={null} onCancel={this.modalCancel}>
            <div style={{width:'100%',minHeight:'400px',display:'flex',justifyContent:'center',alignItems:'center'}}>
              <img alt="example" style={{ maxWidth: '400px' }} src={this.state.previewImage} />
            </div>
          </Modal>
          <Modal title="评分详情"
                 visible={this.state.detailstatus}
                 onCancel={this.handleCancelstatus}
                 footer={[
                   <Button key="submit" type="primary" onClick={this.handleCancelstatus}>
                     取消
                   </Button>
                 ]}
          >
            <div>
              {
                this.state.detaildata.map((item,index)=>{
                  if (index === 0) {
                    return (<div style={{display:'flex',borderBottom:'1px solid #bebebe'}}>
                      {
                        item.map(item2=>{
                          return (
                              <div style={{width:'100px',textAlign:'center'}}>{item2}</div>
                          )
                        })
                      }
                    </div>)
                  } else {
                    return (<div style={{display:'flex',borderBottom:'1px solid #bebebe'}}>
                      {
                        item.map((item3)=>{
                          return (<div style={{width:'100px',textAlign:'center',marginTop:'10px'}}>{item3}</div>)
                        })
                      }
                    </div>)
                  }
                })
              }
            </div>
          </Modal>
        </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    collapsed: state.collapsed,  // 侧边栏是否展开
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps,mapDispatchToProps))(SystemScore);
